import { NamedItem } from "./shared";

/* eslint-disable camelcase */
export enum UserType {
  Customer = "Standard",
  CustomerVIP = "VIP",
  Customer_Internal = "Standard_Internal",
  Groundlight = "SciDuck",
  LabelerAI = "Labeler_AI",
  Manager = "Labeler_2",
  Labeler = "Labeler_1",
  Canary = "Canary",
}

export const userTypeMap: Record<UserType, string> = {
  [UserType.Customer]: "Standard",
  [UserType.CustomerVIP]: "VIP",
  [UserType.Customer_Internal]: "Standard Internal",
  [UserType.Groundlight]: "SciDuck",
  [UserType.LabelerAI]: "Labeler AI",
  [UserType.Manager]: "Labeler Manager",
  [UserType.Labeler]: "Labeler",
  [UserType.Canary]: "Canary",
};

export enum TierType {
  Free = "FREE",
  Paid_1 = "PAID_1",
  Paid_2 = "PAID_2",
  Axon_Internal = "AXON_INTERNAL",
  Enterprise = "ENTERPRISE",
  Unlimited = "UNLIMITED",
  Custom = "CUSTOM",
}

export const tierMap: Record<TierType, string> = {
  [TierType.Free]: "Free",
  [TierType.Paid_1]: "Pro",
  [TierType.Paid_2]: "Business",
  [TierType.Axon_Internal]: "Axon Internal",
  [TierType.Enterprise]: "Enterprise",
  [TierType.Unlimited]: "Unlimited",
  [TierType.Custom]: "Custom",
};

export enum AuthFlow {
  COGNITO = "COGNITO",
  FUSIONAUTH = "FUSIONAUTH",
}

export interface UserProfile {
  accepted_terms_of_service?: string;
  name?: string;
  accepted_at?: string;
  company?: string;
  show_system_accuracy?: boolean;
  customer_type?: UserType;

  // onboarding fields
  detector_detail_onboarded: boolean;
  review_onboarded: boolean;
  data_onboarded: boolean;
  query_detail_onboarded: boolean;
  detector_management_onboarded: boolean;
}

export interface User extends NamedItem {
  username: string;
  tier: TierType;
  groups: Array<NamedItem>;
  is_admin_login_view: boolean;
  is_superuser: boolean;
  is_staff: boolean;
  is_labeler: boolean;
  explore_detector: string | null;
  userprofile: UserProfile;
  accepted_tos: boolean;
  email?: string;
  auth_flow: AuthFlow;
  date_joined: string;
  account_labeling_settings: "FULL_LABELING" | "ONLY_USER_PROVIDED_LABELING";

  // Feature flags
  show_inspections: boolean;
  show_reset_detector_option: boolean;
  // --- Customer type based
  show_labelers_management: boolean;
  enable_idp_migration: boolean;
  can_edit_gl_notes: boolean;
  enable_review_options: boolean;
  show_disagreements: boolean;
  should_create_disagreements: boolean;
  allow_explore_selection: boolean;
  show_full_sources: boolean;
  only_labeler_ui: boolean;
  show_disagreements_management: boolean;
  // --- Customer tier based
  allow_annotations: boolean;
  enable_export_data: boolean;
  enable_count_mode: boolean;
  enable_multi_class_mode: boolean;
  // --- Temporary internal test
  show_system_accuracy: boolean;
  enable_new_detector_notes_editor: boolean;
  enable_data_page_multiselect_filter: boolean;
  enable_text_mode: boolean;
  enable_account_invite: boolean;
  enable_bounding_box_mode: boolean;
  show_pipeline_details_modal: boolean;

  // Account members
  account_members?: number;
}

export interface UserProps {
  user: User;
}
